import ConversationList from './list'
import { StyleWrapper } from './style'

import { FC } from 'react'
interface ConversationsProps {
  sender: any
  receiver: any
}
const Conversations: FC<ConversationsProps> = ({ receiver, sender }) => {
  return (
    <StyleWrapper>
      <ConversationList receiver={receiver} sender={sender} />
    </StyleWrapper>
  )
}

export default Conversations
